import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AutoCreateEvaluationResponse,
  CreatedEvaluationResponse,
  EmployeeEvaluationData,
  EvaluationData,
  GetEvaluationResponse,
} from './evaluation.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.development';

@Injectable({ providedIn: 'root' })
export class EvaluationService {
  private apiUrl = `${environment.apiUrl}/evaluation`;

  constructor(private http: HttpClient) {}

  autoCreateEvaluation(): Observable<AutoCreateEvaluationResponse> {
    return this.http.post<AutoCreateEvaluationResponse>(
      `${this.apiUrl}/automated/create`,
      null
    );
  }

  createEmployeeTypeEvaluation(
    data: EmployeeEvaluationData
  ): Observable<CreatedEvaluationResponse> {
    return this.http.post<CreatedEvaluationResponse>(
      `${this.apiUrl}/employee/create`,
      data
    );
  }

  createEvaluation(
    data: EvaluationData
  ): Observable<CreatedEvaluationResponse> {
    return this.http.put<CreatedEvaluationResponse>(`${this.apiUrl}`, data);
  }

  getEvaluation(id: string): Observable<GetEvaluationResponse> {
    return this.http.get<GetEvaluationResponse>(`${this.apiUrl}/${id}`);
  }

  getEvaluationList(
    organizationId?: string
  ): Observable<GetEvaluationResponse> {
    if (organizationId) {
      return this.http.get<GetEvaluationResponse>(
        `${this.apiUrl}?filters[organization_id]=${organizationId}`
      );
    }
    return this.http.get<GetEvaluationResponse>(`${this.apiUrl}`);
  }
  searchEvaluation(searhTerm?: string): Observable<GetEvaluationResponse> {
    if (searhTerm) {
      return this.http.get<GetEvaluationResponse>(
        `${this.apiUrl}?search=${searhTerm}`
      );
    }
    return this.http.get<GetEvaluationResponse>(`${this.apiUrl}`);
  }
}
